module.exports = __webpack_public_path__ + "img/step5.4a9106e2.png";